import Text from 'components/Text/Text';
import React, { useCallback } from 'react';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import { TTypeOfEditGameModalWindow } from 'modules/Entertainment/Games/EditGame/editGameState/editGameContext';
import style from './CreateDeveloperBtn.module.scss';

interface IEditDeveloperBtn {
	changeTypeOfModalWindow: (value: TTypeOfEditGameModalWindow) => void;
}

const EditDeveloperBtn: React.FC<IEditDeveloperBtn> = ({ changeTypeOfModalWindow }) => {
	const handleEdit = useCallback(() => {
		changeTypeOfModalWindow('createDeveloper');
	}, [changeTypeOfModalWindow]);

	return (
		<Button
			className={style.btn}
			data-test="CreateDeveloperBtn"
			icon={
				<svg className={style.icon}>
					<use xlinkHref={`${breadcrumbs}#plus`} />
				</svg>
			}
			onClick={handleEdit}>
			<Text translationNameSpace="form" translationKey="createDeveloperButton" asFragment={true} />
		</Button>
	);
};

export default React.memo(EditDeveloperBtn);
